import React, { useState, useEffect } from 'react';
import { Phone, Calendar, X } from 'lucide-react';

const StickyCTABar = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past 600px (past hero)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible || dismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 animate-slide-down" data-testid="sticky-cta-bar">
      <div className="bg-gradient-to-r from-[#0066b3] to-[#004a82] text-white py-2.5 px-4 shadow-lg">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-4 text-sm">
            <span className="font-semibold hidden sm:inline">Best Hospital in Chennai</span>
            <span className="text-white/60 hidden sm:inline">|</span>
            <a
              href="tel:+914428442626"
              onClick={() => { if(window.dataLayer) window.dataLayer.push({event: 'click_to_call', call_source: 'sticky_cta_bar'}); }}
              className="flex items-center gap-1.5 hover:underline font-medium"
            >
              <Phone size={14} /> +91 44 2844 2626
            </a>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="#home"
              onClick={(e) => { e.preventDefault(); document.getElementById('home')?.scrollIntoView({behavior: 'smooth'}); }}
              className="flex items-center gap-1.5 bg-white text-[#0066b3] px-4 py-1.5 rounded-full text-xs font-bold hover:bg-gray-50 transition-colors"
            >
              <Calendar size={12} /> Book Now
            </a>
            <button onClick={() => setDismissed(true)} className="text-white/60 hover:text-white">
              <X size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyCTABar;
